import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'
import constructRequestData from '../../constructRequestData'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './AccountRecovery.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'post /account-recovery': 200,
    // 'post /account-recovery/verify-otp': 200,
    // 'post /account-recovery/update-mobile': 200,
    // 'post /account-recovery/verify-otp-mobile': 200,
    // 'post /account-recovery/update-mobile/resend': 200,
  })
}

export const postRequestRecovery = ({ email }) => {}

export const postVerifyOtpRecovery = ({ requestId, code }) => {}

export const postUpdateMobileRecovery = ({ requestId, mobile }) => {}

export const postVerifyUpdateMobileOtp = ({ requestId, code }, fcmToken) => {}

export const resendUpdateMobile = ({ requestId }) => {}
